import { render, staticRenderFns } from "./EbCargoInfoEn.vue?vue&type=template&id=66f33908&scoped=true&"
import script from "./EbCargoInfoEn.vue?vue&type=script&lang=js&"
export * from "./EbCargoInfoEn.vue?vue&type=script&lang=js&"
import style0 from "./EbCargoInfoEn.vue?vue&type=style&index=0&id=66f33908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f33908",
  null
  
)

export default component.exports